import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=63b2784b&scoped=true&"
import script from "./index1.vue?vue&type=script&lang=js&"
export * from "./index1.vue?vue&type=script&lang=js&"
import style0 from "./index1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./index1.vue?vue&type=style&index=1&id=63b2784b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2784b",
  null
  
)

export default component.exports